/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProfileWebPreferences
 */
export interface ProfileWebPreferences {
    /**
     * 
     * @type {boolean}
     * @memberof ProfileWebPreferences
     */
    onboardingAcknowledged: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileWebPreferences
     */
    productTourAcknowledged: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileWebPreferences
     */
    portfolioShareProductTourAcknowledged: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileWebPreferences
     */
    portfolioEditorProductTourAcknowledged: boolean;
}

/**
 * Check if a given object implements the ProfileWebPreferences interface.
 */
export function instanceOfProfileWebPreferences(value: object): value is ProfileWebPreferences {
    if (!('onboardingAcknowledged' in value) || value['onboardingAcknowledged'] === undefined) return false;
    if (!('productTourAcknowledged' in value) || value['productTourAcknowledged'] === undefined) return false;
    if (!('portfolioShareProductTourAcknowledged' in value) || value['portfolioShareProductTourAcknowledged'] === undefined) return false;
    if (!('portfolioEditorProductTourAcknowledged' in value) || value['portfolioEditorProductTourAcknowledged'] === undefined) return false;
    return true;
}

export function ProfileWebPreferencesFromJSON(json: any): ProfileWebPreferences {
    return ProfileWebPreferencesFromJSONTyped(json, false);
}

export function ProfileWebPreferencesFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProfileWebPreferences {
    if (json == null) {
        return json;
    }
    return {
        
        'onboardingAcknowledged': json['onboardingAcknowledged'],
        'productTourAcknowledged': json['productTourAcknowledged'],
        'portfolioShareProductTourAcknowledged': json['portfolioShareProductTourAcknowledged'],
        'portfolioEditorProductTourAcknowledged': json['portfolioEditorProductTourAcknowledged'],
    };
}

export function ProfileWebPreferencesToJSON(value?: ProfileWebPreferences | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'onboardingAcknowledged': value['onboardingAcknowledged'],
        'productTourAcknowledged': value['productTourAcknowledged'],
        'portfolioShareProductTourAcknowledged': value['portfolioShareProductTourAcknowledged'],
        'portfolioEditorProductTourAcknowledged': value['portfolioEditorProductTourAcknowledged'],
    };
}

